// <s-marquee> — seamless horizontal ticker. Clones the authored group so the loop never gaps.
class SMarquee extends HTMLElement {
  #ac;
  #ro;

  connectedCallback() {
    this.#ac = new AbortController();
    const track = this.querySelector('[data-marquee-track]');
    const group = this.querySelector('[data-marquee-group]');
    const toggle = this.querySelector('[data-marquee-toggle]');
    if (!track || !group) return;

    const fill = () => {
      track.querySelectorAll('[data-marquee-clone]').forEach((node) => node.remove());
      if (!this.hasAttribute('animate')) return;
      const groupWidth = group.getBoundingClientRect().width;
      if (groupWidth === 0) return;
      // Enough copies to cover the viewport twice so translate(-50%) loops cleanly.
      const copies = Math.max(1, Math.ceil((this.clientWidth * 2) / groupWidth));
      const total = copies % 2 === 0 ? copies : copies + 1;
      for (let i = 1; i < total; i++) {
        const clone = group.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        clone.setAttribute('inert', '');
        clone.removeAttribute('data-marquee-group');
        clone.setAttribute('data-marquee-clone', '');
        track.appendChild(clone);
      }
      this.style.setProperty('--marquee-copies', String(total));
    };

    fill();
    this.#ro = new ResizeObserver(() => fill());
    this.#ro.observe(this);

    if (toggle) {
      toggle.addEventListener(
        'click',
        () => {
          const paused = this.toggleAttribute('paused');
          toggle.setAttribute('aria-pressed', String(paused));
          toggle.setAttribute('aria-label', paused ? toggle.dataset.playLabel : toggle.dataset.pauseLabel);
        },
        { signal: this.#ac.signal }
      );
    }
  }

  disconnectedCallback() {
    this.#ac?.abort();
    this.#ro?.disconnect();
  }
}

if (!customElements.get('s-marquee')) customElements.define('s-marquee', SMarquee);
